import request from "@/utils/request";
//1, 获取数据字典
// domain: 所属领域
// demand_category: 需求类型
// obtain_way: 获取方式
// company_category: 意向合作单位
// maturity: 成熟度
// result_level: 成果水平
// region: 所在区域
// ip_right: 知识产权
// transfer_way: 转让方式
// institution: 所属机构
// device_category: 设备类别
// price_range: 价格范围
export function getAllDataDict(key){
    return request({
        url:'/getAllDataDict',
        data:{key:key},
        method:'get'
    })
}

